import { useCallback, useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

type Params = {
  stickyElementRef: {
    current: HTMLElement;
  };
  scrollingElementRef: {
    current: HTMLElement;
  };
  offsetTop?: number;
};

type ReturnType = { isSticky: Boolean };

export function useStickyObserver({ stickyElementRef, scrollingElementRef, offsetTop = 0 }: Params): ReturnType {
  const [isSticky, setSticky] = useState(false);

  const handleScroll = useCallback(() => {
    if (stickyElementRef.current) {
      setSticky(stickyElementRef.current.getBoundingClientRect().top <= offsetTop);
    }
  }, [stickyElementRef, offsetTop]);

  const throttleHandleScroll = useCallback(throttle(handleScroll, 200), [handleScroll]);

  useEffect(() => {
    const scrollingNode = scrollingElementRef?.current;
    if (scrollingNode) scrollingNode.addEventListener('scroll', throttleHandleScroll);
    return () => {
      if (scrollingNode) scrollingNode.removeEventListener('scroll', throttleHandleScroll);
    };
  }, []);
  return { isSticky };
}
